var map = {
	"./check_box.svg": "6871",
	"./check_box_outline_blank.svg": "75d7",
	"./indeterminate_check_box.svg": "9638",
	"./radio_button_checked.svg": "2271",
	"./radio_button_unchecked.svg": "1403",
	"./star.svg": "36ca",
	"./star_border.svg": "8313",
	"./star_half.svg": "6347"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be86";